// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "2cf0dc6271376b0225c75628a4207d5f0c575d65/static/css/" + chunkId + "." + {"725":"84c1fc5e","831":"583e16c7","854":"36854e5e"}[chunkId] + ".chunk.css";
};